import React from 'react';
import {
  Box,
  Typography,
  Button,
  Card,
  CardContent,
  Stack,
  Grid,
} from '@mui/material';

const OTPGeneration = ({ onComplete }) => {
  const steps = [
    {
      title: 'Visit Fatoora Portal',
      description: 'Go to the official Fatoora portal',
      arDescription: 'انتقل إلى بوابة فاتورة الرسمية'
    },
    {
      title: 'Login to Your Account',
      description: 'Sign in with your VAT credentials',
      arDescription: 'قم بتسجيل الدخول باستخدام بيانات ضريبة القيمة المضافة'
    },
    {
      title: 'Generate OTP',
      description: 'Navigate to the OTP generation section and request a new OTP',
      arDescription: 'انتقل إلى قسم إنشاء رمز OTP واطلب رمزًا جديدًا'
    },
    {
      title: 'Save OTP',
      description: 'Copy and save the generated OTP securely',
      arDescription: 'انسخ واحفظ رمز OTP المُنشأ بشكل آمن'
    }
  ];

  return (
    <Box>
      <Card 
        variant="outlined" 
        sx={{ 
          mb: 4,
          borderRadius: 0,
          borderColor: 'divider',
          width: '100%',
          minHeight: 420
        }}
      >
        <CardContent>
          <Typography 
            variant="subtitle1" 
            sx={{ 
              mb: 3,
              fontWeight: 500,
              color: 'text.secondary',
              fontSize: '0.875rem'
            }}
          >
            Follow these steps to generate your OTP from the Fatoora portal:
          </Typography>

          <Stack spacing={2}>
            {steps.map((item, index) => (
              <Box
                key={index}
                sx={{
                  p: 2,
                  border: '1px solid',
                  borderColor: 'divider',
                  borderRadius: 0,
                  bgcolor: 'background.paper',
                  display: 'flex',
                  gap: 2
                }}
              >
                <Box
                  sx={{
                    width: 24,
                    height: 24,
                    borderRadius: '50%',
                    bgcolor: 'primary.main',
                    color: 'white',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '0.875rem',
                    fontWeight: 500,
                    flexShrink: 0
                  }}
                >
                  {index + 1}
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography 
                    variant="subtitle1" 
                    sx={{ 
                      fontWeight: 500,
                      color: 'text.primary',
                      mb: 0.5
                    }}
                  >
                    {item.title}
                  </Typography>
                  <Grid container spacing={1} alignItems="center">
                    <Grid item xs={6}>
                      <Typography 
                        variant="body2" 
                        sx={{ 
                          color: 'text.secondary',
                          lineHeight: 1.2
                        }}
                      >
                        {item.description}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography 
                        variant="body2" 
                        sx={{ 
                          color: 'text.secondary',
                          textAlign: 'right',
                          direction: 'rtl',
                          lineHeight: 1.2
                        }}
                      >
                        {item.arDescription}
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
              </Box>
            ))}
          </Stack>

          <Box sx={{ mt: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Button
              variant="outlined"
              href="https://fatoora.zatca.gov.sa"
              target="_blank"
              rel="noopener noreferrer"
              sx={{ 
                borderRadius: 0,
                textTransform: 'none',
                fontWeight: 500,
                fontSize: '0.875rem',
                px: 3,
                py: 1
              }}
            >
              Go to Fatoora Portal
            </Button>
          </Box>
        </CardContent>
      </Card>

      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button
          variant="contained"
          onClick={onComplete}
          sx={{ 
            px: 3,
            py: 1,
            borderRadius: 0,
            textTransform: 'none',
            fontWeight: 500,
            fontSize: '0.875rem'
          }}
        >
          I have generated my OTP
        </Button>
      </Box>
    </Box>
  );
};

export default OTPGeneration; 